import React, { useState } from "react";
import { Box, MenuItem, Stack, Typography } from "@mui/material";
import Logo from "./Logo";
import IConButtonApp from "../../IconButtonApp/IConButtonApp";
import { LuMenu } from "react-icons/lu";
import DrawerBase from "../../drawer/DrawerBase";
import AvatarApp from "../../avatarapp/AvatarApp";
import { useSelector } from "react-redux";
import { generateLinkImage } from "../../../../utils/helpers";
import ModalUser from "../../modal/ModalUser";

function HeaderMobile() {
  const profile = useSelector((state: any) => state.auth.profile);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openModalUser, setOpenModalUser] = useState<boolean>(false);

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  return (
    <>
      {openModalUser && (
        <ModalUser
          open={openModalUser}
          onClose={() => setOpenModalUser(false)}
        />
      )}
      <DrawerBase anchor="right" open={openMenu} onClose={handleCloseMenu}>
        <Box sx={{ width: "70vw" }}>
          {/* User info */}
          <Stack
            onClick={() => setOpenModalUser(true)}
            component={MenuItem}
            direction="row"
            alignItems="center"
            gap={1}
            sx={{
              p: 1,
              height: "80px",
              backgroundColor: "primary.main",
              "&:hover": { backgroundColor: "primary.main" },
            }}
          >
            <AvatarApp
              name={profile?.name}
              src={
                profile?.picture && profile?.picture !== "/images/avatar.jpg"
                  ? generateLinkImage(profile?.picture)
                  : ""
              }
              sx={{
                width: 60,
                height: 60,
                border: "2px solid",
                borderColor: "common.white",
              }}
            />
            <Stack>
              <Typography sx={{ color: "common.white" }}>
                <Typography
                  component="span"
                  sx={{ fontSize: "18px", fontWeight: 600 }}
                >
                  Xin chào
                </Typography>{" "}
                <Typography component="span">{profile?.name}</Typography>
              </Typography>
              <Typography
                sx={{
                  color: "common.white",
                  whiteSpace: "wrap",
                }}
              >
                {profile?.email}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </DrawerBase>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          display: { xs: "flex", md: "none" },
          width: "100%",
          height: "100%",
          px: 2,
        }}
      >
        <Logo />
        <IConButtonApp
          sx={{ width: "45px", height: "45px" }}
          onClick={() => setOpenMenu(true)}
        >
          <LuMenu size={20} />
        </IConButtonApp>
      </Stack>
    </>
  );
}

export default HeaderMobile;
